import { Grid, Tab } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import {
  ActiveIndicatorIcon,
  ArrowDownIcon,
  ArrowDownIconTwoTone,
  ArrowUpIconTwoTone,
  Avatar,
  EditIconTwoTone,
  ITab,
  NotificationAlertIcon,
  ProjectDetailsIcon,
  StyledMenu,
  Typography,
} from '@room-match/shared-ui-components';
import React, { useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { navigateToRoute } from 'shared/utils/navigateToRoute';
import {
  ActiveText,
  Body,
  Content,
  CustomMenuItem,
  CustomMenuItemChildContainer,
  CustomTabs,
  Dismissed,
  FlexRow,
  ItemHeader,
  LightBulb,
  MoreIcon,
  New,
  NotificationBox,
  ProjectDetails,
  ProjectDetailsButton,
  Revised,
  Submitted,
  ToggleButton,
  Viewed,
} from './List.styles';
import Progress from './Progress/Progress';
import Summary from './Summary/Summary';

const tabs = [
  {
    name: 'summary',
    header: 'Summary',
    component: <div>Hello</div>,
    disabled: false,
  },
  {
    name: 'progress',
    header: 'Progress',
    component: <div />,
    disabled: false,
  },
  {
    name: 'roles',
    header: 'Roles',
    component: <div />,
    disabled: true,
  },
  {
    name: 'in_studio',
    header: 'In Studio',
    component: <div />,
    disabled: true,
  },
  {
    name: 'self_tapes',
    header: 'Self-Tapes',
    component: <div />,
    disabled: true,
  },
  {
    name: 'worksheet',
    header: 'Worksheet',
    component: <div />,
    disabled: true,
  },
];

type Props = {
  data: any;
  handleOpenProjectDetailModel: (project: IProjectAttributes) => void;
};

const List: React.FC<Props> = ({ data, handleOpenProjectDetailModel }) => {
  const [tab, setTab] = useState<string>('progress');
  const history = useHistory();
  const [menuEl, setMenuEl] = useState<Element | null>(null);
  const [expand, setExpand] = useState(true);

  const handleCloseMenu = () => setMenuEl(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => setMenuEl(event.currentTarget);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setTab(newValue);
  };

  const toggleAcordion = () => {
    setExpand(!expand);
  };

  const handleRedirectEditProject = () => {
    // history.push(navigateToRoute.toEditProject(data.id));
  };

  const getActiveTab = useMemo(() => {
    const currentTab = tabs.find((_tab) => _tab.name === tab);
    if (currentTab?.name === 'summary') {
      currentTab.component = <Summary data={data} />;
      return currentTab?.component;
    }

    if (currentTab?.name === 'progress') {
      currentTab.component = <Progress data={data} />;
      return currentTab?.component;
    }

    return tabs.find((_tab) => _tab.name === tab)?.component;
  }, [tab, data]);

  return (
    <Body expanded={expand} key={data.name}>
      <ItemHeader>
        <FlexRow style={{ width: 265 }}>
          <NotificationBox>
            <NotificationAlertIcon style={{ width: 18 }} /> 0
          </NotificationBox>

          <ProjectDetails>
            <Typography fontSize={15}>{data.name}</Typography>
            <Typography fontSize={13} color="mainGrey">
              {data.sag_aftra_contract_type}
            </Typography>
            <Typography fontSize={13} color="primary">
              {data.agency}
            </Typography>
          </ProjectDetails>
        </FlexRow>
        <FlexRow style={{ width: 120, justifyContent: 'center' }}>
          {data.action_status === 'new' ? (
            <New>{data.action_status}</New>
          ) : data.action_status === 'revised' ? (
            <Revised>{data.action_status}</Revised>
          ) : data.action_status === 'viewed' ? (
            <Viewed>{data.action_status}</Viewed>
          ) : data.action_status === 'submitted' ? (
            <Submitted>{data.action_status}</Submitted>
          ) : (
            <Dismissed>{data.action_status}</Dismissed>
          )}
        </FlexRow>

        <CustomTabs value={tab} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
          {tabs.map((tab, index) => (
            <Tab
              key={index}
              label={tab.header}
              disabled={tab.disabled}
              value={tab.name}
              style={{ textTransform: 'capitalize', fontSize: '15px' }}
            />
          ))}
        </CustomTabs>
        <FlexRow style={{ marginLeft: 'auto' }}>
          <ProjectDetailsButton onClick={() => handleOpenProjectDetailModel(data)}>
            <ProjectDetailsIcon />
            <Typography fontSize={14}>Project Details</Typography>
          </ProjectDetailsButton>
          <ToggleButton onClick={toggleAcordion}>
            {expand ? <ArrowUpIconTwoTone /> : <ArrowDownIconTwoTone />}
          </ToggleButton>
          <MoreIcon onClick={handleOpenMenu}>
            <MoreVert style={{ color: '#6e767f' }} />
          </MoreIcon>
          <StyledMenu
            id="simple-menu"
            anchorEl={menuEl}
            open={Boolean(menuEl)}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            getContentAnchorEl={null}
          >
            <CustomMenuItem onClick={() => handleRedirectEditProject()}>
              <CustomMenuItemChildContainer>
                <EditIconTwoTone style={{ fontSize: 16 }} />
                <Typography style={{ fontSize: 13 }}>Edit Project</Typography>
              </CustomMenuItemChildContainer>
            </CustomMenuItem>
          </StyledMenu>
        </FlexRow>
      </ItemHeader>
      <Content>{getActiveTab}</Content>
    </Body>
  );
};

export default List;
